import React from 'react';
import { 
	object,
	string,
	oneOfType
} from 'prop-types';
import SingleContentLayout from '../../templates/SingleContentLayout';
import ErrorContent from '../../organisms/ErrorContent/index';

const ErrorPage = ({error,message = 'Somethingg error happens'})=>{
	return <SingleContentLayout 
		render={()=><ErrorContent 
			message={message}
			detail={error}
		/>}
	/>;
};
ErrorPage.propTypes = {
	error : oneOfType([string,object]),
	message : string
};
export default ErrorPage;